import { css } from 'linaria';
import { strictBreakpoints } from 'media';

export const cardListStyles = css`
	.card-list__gallery {
		display: grid;
		grid-gap: 32px;
		grid-template-columns: repeat(4, 170px);
		margin-top: 40px;
		${strictBreakpoints.onlyTablet} {
			grid-template-columns: repeat(4, 141px);
		}
	}
`;
export const wrapperCardClassName = css`
	padding-bottom: 0;
`;
